import { GraduationCap, HeartHandshake, Award } from "lucide-react";
import { RANKS } from "@/lib/progression";

const ICONS = { trainee: GraduationCap, advocate: HeartHandshake, counselor: Award };
const PILL = {
  trainee: "bg-amber-100 text-amber-800 ring-amber-200",
  advocate: "bg-sky-100 text-sky-800 ring-sky-200",
  counselor: "bg-emerald-100 text-emerald-800 ring-emerald-200",
};

export const RankBadge = ({ rank = "trainee", className = "" }) => {
  const meta = RANKS[rank] || RANKS.trainee;
  const Icon = ICONS[rank] || GraduationCap;
  return (
    <span
      data-testid="rank-badge"
      className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold ring-1 ${PILL[rank]} ${className}`}
    >
      <Icon className="h-3.5 w-3.5" />
      {meta.title}
    </span>
  );
};
